import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { getSessionId } from "../featureFlags";
import {
  getBrowserName,
  getBrowserVersion,
  getDeviceType,
  getOSName,
  getOSVersion,
  getWindowDimension,
} from "./deviceInformation";
import type { ClientEvent, EventShellData, TrackEventPayload } from "./types";

export const createClientEvent = (
  payload: TrackEventPayload,
  shellData: EventShellData
): ClientEvent => {
  const sessionId =
    datadogRum.getInternalContext()?.session_id ||
    datadogLogs.getInternalContext()?.session_id ||
    getSessionId();

  const { account, user } = shellData;

  if (!sessionId) {
    console.error("SessionId is not set");
  }
  return {
    eventInfo: {
      eventAction: payload.action || "",
      eventSessionId: sessionId || "",
      eventTag: payload.tag || "",
      eventTarget: "",
      eventTimestamp: Date.now(),
      eventTracingId: payload.id,
      eventType: payload.type || "com.sinch.onesaas.user_interaction",
      eventValue: "",
    },
    userInfo: {
      userAccountId: account?.account_id || 0,
      userAccountName: account?.company || "",
      userCountry: account?.country || "",
      userId: user.id || "",
      userLanguage: user.language ?? "",
      userProjectId: user.activeProject || "",
      userRoles: user.roles || [],
      userTier: "",
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    deviceInfo: {
      deviceId: "",
      deviceType: getDeviceType(),
      deviceViewportSize: `${getWindowDimension().width}x${
        getWindowDimension().height
      }`,
      deviceOs: getOSName(),
      deviceOsVersion: getOSVersion(),
      deviceModel: "",
      deviceBrand: "",
      deviceBrowser: getBrowserName(),
      deviceBrowserVersion: getBrowserVersion(),
    },
    appInfo: {
      appName: "Engage",
      appMfe: payload.appName,
      appVersion: "",
      appDomain: window.location.hostname,
    },
    pageInfo: {
      pageUrl: payload.source,
      PrevPageURL: "",
    },
    experimentInfo: {
      experimentName: payload.experimentInfo?.experimentId || "",
      experimentBucket: payload.experimentInfo?.bucketId || "",
    },
    specificInfo: payload.customInfo || payload.specificInfo,
  };
};
